import { colors, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';
import L from 'leaflet';

import plannedPlaceIconUrl from '../icons/ic_place_planned.svg';

const icon = css`
  cursor: pointer;
  filter: drop-shadow(0px 4px 4px rgba(7, 7, 78, 0.2));

  & > span {
    top: 4px;
    left: 50%;
    position: absolute;
    text-align: center;
    transform: translate(-40%, 5%);
    font-size: 12px;
    font-weight: ${fontWeight.bold};
    color: ${colors.primary[9]};
  }
`;

export const PlannedStopIcon = (index: number) => {
  const numberSpan = `<span>${index}</span>`;
  const placeImage = `<img src="${plannedPlaceIconUrl}" />`;
  return new L.DivIcon({
    html: `<div class="${icon}">${numberSpan}${placeImage}</div>`,
    iconSize: [27, 33],
    iconAnchor: [13.5, 33],
  });
};
